module.exports = __webpack_public_path__ + "static/media/aroma-aromatherapy-healthy-life-svgrepo-com.d083c105.svg";